import { z } from 'zod/v4';

import { columns, columnValidators } from './columns';

export const teamConfigSchema = z.object(columns);

export type TeamConfig = z.output<typeof teamConfigSchema>;

export const teamConfigInsertSchema = teamConfigSchema.omit({
  uuid: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
});

export type InsertableTeamConfig = z.output<typeof teamConfigInsertSchema>;

export const teamConfigUpdateSchema = columnValidators;
